import React from "react";

interface HeroProps {
  onBookingClick: () => void;
}

export default function Hero({ onBookingClick }: HeroProps) {
  const topRowImages = [
    "/images/KLAR-ki_logo-symbol%402x.png",
    "/images/frau_ki-netz.png",
    "/images/man_ki-relaxed.png",
    "/images/frauen_ki-screen.png",
    "/images/frau_team_ki-explaining.png",
  ];

  const bottomRowImages = [
    "/images/frau_ki-netz.png",
    "/images/frau_ki-netz.png",
    "/images/frau_ki-netz.png",
    "/images/frau_ki-netz.png",
  ];

  return (
    <section className="relative pt-32 pb-20 px-6 lg:px-12 bg-[#042A60] overflow-hidden">
      <div className="max-w-4xl mx-auto text-center mb-16">
        <h1 className="text-4xl lg:text-6xl text-white mb-6 leading-tight font-light">
          KI, die mitarbeitet – nicht überfordert
        </h1>
        <p className="text-base lg:text-lg text-white/90 mb-8 leading-relaxed max-w-3xl mx-auto">
          klar:ki übersetzt künstliche Intelligenz in verständliche Assistent:innen, die deinen
          Arbeitsalltag leichter und dein Geschäft nachhaltig erfolgreicher machen. Konkrete KI-
          Assistent:innen statt Tool-Chaos. Messbare Effizienz und Wachstum statt Experimente.
          Menschliche Intelligenz bleibt im Mittelpunkt – KI unterstützt, ersetzt nicht.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={onBookingClick}
            className="px-8 py-3 bg-[#0A6AF0] text-white text-base font-normal hover:bg-[#0858c7] transition-colors cursor-pointer whitespace-nowrap"
          >
            Klarheitsgespräch buchen
          </button>
        </div>
      </div>

      {/* Statische Bildergalerie - 1 Reihe */}
      <div className="max-w-6xl mx-auto">
        {/* Obere Reihe - links angeschnitten */}
        <div className="flex gap-4 mb-4 -ml-16">
          {topRowImages.map((img, index) => (
            <div
              key={index}
              className={`flex-shrink-0 overflow-hidden ${
                index === 0 ? "w-48 lg:w-56" : "w-56 lg:w-64"
              } h-40 lg:h-48`}
            >
              <img
                src={img}
                alt={`Team member ${index + 1}`}
                className="w-full h-full object-cover object-top"
              />
            </div>
          ))}
        </div>
        {/* Optional: you can add the bottom row here if needed */}
      </div>
    </section>
  );
}